var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.16406C0 3.29807 3.13401 0.164062 7 0.164062H128C131.866 0.164062 135 3.29807 135 7.16406V33.1641C135 37.0301 131.866 40.1641 128 40.1641H7C3.13401 40.1641 0 37.0301 0 33.1641V7.16406Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.9149C65.784 21.9149 63.867 23.7039 63.867 26.1679C63.867 28.6169 65.784 30.4209 68.136 30.4209C70.489 30.4209 72.406 28.6169 72.406 26.1679C72.405 23.7039 70.488 21.9149 68.136 21.9149ZM68.136 28.7469C66.847 28.7469 65.736 27.6839 65.736 26.1689C65.736 24.6379 66.848 23.5909 68.136 23.5909C69.425 23.5909 70.536 24.6379 70.536 26.1689C70.536 27.6829 69.425 28.7469 68.136 28.7469ZM58.822 21.9149C56.47 21.9149 54.553 23.7039 54.553 26.1679C54.553 28.6169 56.47 30.4209 58.822 30.4209C61.175 30.4209 63.092 28.6169 63.092 26.1679C63.092 23.7039 61.175 21.9149 58.822 21.9149ZM58.822 28.7469C57.533 28.7469 56.422 27.6839 56.422 26.1689C56.422 24.6379 57.534 23.5909 58.822 23.5909C60.111 23.5909 61.222 24.6379 61.222 26.1689C61.223 27.6829 60.111 28.7469 58.822 28.7469ZM47.744 23.2209V25.0249H52.062C51.933 26.0399 51.595 26.7809 51.079 27.2959C50.451 27.9239 49.468 28.6169 47.744 28.6169C45.086 28.6169 43.008 26.4739 43.008 23.8159C43.008 21.1579 45.086 19.0149 47.744 19.0149C49.178 19.0149 50.225 19.5789 50.998 20.3039L52.271 19.0309C51.191 17.9999 49.758 17.2109 47.744 17.2109C44.103 17.2109 41.042 20.1749 41.042 23.8159C41.042 27.4569 44.103 30.4209 47.744 30.4209C49.709 30.4209 51.192 29.7759 52.351 28.5679C53.543 27.3759 53.914 25.6999 53.914 24.3469C53.914 23.9289 53.882 23.5419 53.817 23.2199H47.744V23.2209ZM93.052 24.6219C92.698 23.6719 91.618 21.9149 89.411 21.9149C87.22 21.9149 85.399 23.6389 85.399 26.1679C85.399 28.5519 87.204 30.4209 89.62 30.4209C91.569 30.4209 92.697 29.2289 93.165 28.5359L91.715 27.5689C91.232 28.2779 90.571 28.7449 89.62 28.7449C88.67 28.7449 87.993 28.3099 87.558 27.4559L93.245 25.1039L93.052 24.6219ZM87.252 26.0399C87.204 24.3959 88.525 23.5589 89.476 23.5589C90.217 23.5589 90.845 23.9299 91.055 24.4609L87.252 26.0399ZM82.629 30.1639H84.497V17.6629H82.629V30.1639ZM79.567 22.8659H79.503C79.084 22.3659 78.278 21.9149 77.264 21.9149C75.137 21.9149 73.188 23.7839 73.188 26.1849C73.188 28.5689 75.137 30.4219 77.264 30.4219C78.279 30.4219 79.084 29.9709 79.503 29.4559H79.567V30.0679C79.567 31.6949 78.697 32.5649 77.296 32.5649C76.152 32.5649 75.443 31.7439 75.153 31.0509L73.526 31.7279C73.993 32.8549 75.233 34.2409 77.296 34.2409C79.487 34.2409 81.34 32.9519 81.34 29.8099V22.1739H79.568V22.8659H79.567ZM77.425 28.7469C76.136 28.7469 75.057 27.6669 75.057 26.1849C75.057 24.6859 76.136 23.5909 77.425 23.5909C78.697 23.5909 79.696 24.6859 79.696 26.1849C79.696 27.6669 78.697 28.7469 77.425 28.7469ZM101.806 17.6629H97.335V30.1639H99.2V25.4279H101.805C103.873 25.4279 105.907 23.9309 105.907 21.5459C105.907 19.1609 103.874 17.6629 101.806 17.6629ZM101.854 23.6879H99.2V19.4029H101.854C103.249 19.4029 104.041 20.5579 104.041 21.5459C104.041 22.5139 103.249 23.6879 101.854 23.6879ZM113.386 21.8929C112.035 21.8929 110.636 22.4879 110.057 23.8069L111.713 24.4979C112.067 23.8069 112.727 23.5809 113.418 23.5809C114.383 23.5809 115.364 24.1599 115.38 25.1889V25.3179C115.042 25.1249 114.318 24.8359 113.434 24.8359C111.649 24.8359 109.831 25.8169 109.831 27.6499C109.831 29.3229 111.295 30.3999 112.935 30.3999C114.189 30.3999 114.881 29.8369 115.315 29.1769H115.379V30.1419H117.181V25.3489C117.182 23.1309 115.524 21.8929 113.386 21.8929ZM113.16 28.7439C112.55 28.7439 111.697 28.4379 111.697 27.6819C111.697 26.7169 112.759 26.3469 113.676 26.3469C114.495 26.3469 114.882 26.5239 115.38 26.7649C115.235 27.9239 114.238 28.7439 113.16 28.7439ZM123.743 22.1659L121.604 27.5859H121.54L119.32 22.1659H117.31L120.639 29.7409L118.741 33.9549H120.687L125.818 22.1659H123.743ZM106.937 30.1639H108.802V17.6629H106.937V30.1639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.4073C47.418 11.2453 47.1701 11.9123 46.673 12.4103C46.109 13.0023 45.3731 13.2983 44.4691 13.2983C43.6031 13.2983 42.8661 12.9982 42.2611 12.3982C41.6551 11.7972 41.3521 11.0532 41.3521 10.1652C41.3521 9.27625 41.6551 8.53225 42.2611 7.93225C42.8661 7.33125 43.6031 7.03125 44.4691 7.03125C44.8991 7.03125 45.3101 7.11525 45.7001 7.28225C46.0911 7.45025 46.404 7.67325 46.6381 7.95225L46.111 8.48025C45.714 8.00525 45.167 7.76825 44.468 7.76825C43.836 7.76825 43.29 7.99025 42.829 8.43425C42.368 8.87825 42.1381 9.45525 42.1381 10.1643C42.1381 10.8733 42.368 11.4502 42.829 11.8942C43.29 12.3382 43.836 12.5602 44.468 12.5602C45.138 12.5602 45.6971 12.3372 46.1441 11.8902C46.4341 11.5992 46.602 11.1942 46.647 10.6752H44.468V9.95425H47.375C47.405 10.1113 47.418 10.2623 47.418 10.4073Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.90131H49.2961V9.80331H51.7601V10.5243H49.2961V12.4263H52.0281V13.1643H48.5251V7.16431H52.0281V7.90131Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.1643H54.508V7.90131H52.832V7.16431H56.955V7.90131H55.279V13.1643Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.1643V7.16431H60.709V13.1643H59.938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.1643H63.3572V7.90131H61.6812V7.16431H65.8042V7.90131H64.1281V13.1643Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.3893C73.0189 12.9953 72.2859 13.2983 71.4089 13.2983C70.5319 13.2983 69.7989 12.9953 69.2099 12.3893C68.6199 11.7833 68.3259 11.0413 68.3259 10.1643C68.3259 9.2873 68.6199 8.5453 69.2099 7.9393C69.7989 7.3333 70.5319 7.0293 71.4089 7.0293C72.2809 7.0293 73.0129 7.3343 73.6049 7.9433C74.1969 8.5523 74.4929 9.2923 74.4929 10.1643C74.4929 11.0413 74.1979 11.7833 73.6089 12.3893ZM69.7789 11.8863C70.2229 12.3363 70.7659 12.5603 71.4089 12.5603C72.0519 12.5603 72.5959 12.3353 73.0389 11.8863C73.4829 11.4363 73.7059 10.8623 73.7059 10.1643C73.7059 9.4663 73.4829 8.8923 73.0389 8.4423C72.5959 7.9923 72.0519 7.7683 71.4089 7.7683C70.7659 7.7683 70.2229 7.9933 69.7789 8.4423C69.3359 8.8923 69.1129 9.4663 69.1129 10.1643C69.1129 10.8623 69.3359 11.4363 69.7789 11.8863Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.1643V7.16431H76.513L79.429 11.8313H79.4619L79.429 10.6753V7.16431H80.1999V13.1643H79.3949L76.344 8.27031H76.3109L76.344 9.42631V13.1643H75.5749Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.4073C47.418 11.2453 47.1701 11.9123 46.673 12.4103C46.109 13.0023 45.3731 13.2983 44.4691 13.2983C43.6031 13.2983 42.8661 12.9982 42.2611 12.3982C41.6551 11.7972 41.3521 11.0532 41.3521 10.1652C41.3521 9.27625 41.6551 8.53225 42.2611 7.93225C42.8661 7.33125 43.6031 7.03125 44.4691 7.03125C44.8991 7.03125 45.3101 7.11525 45.7001 7.28225C46.0911 7.45025 46.404 7.67325 46.6381 7.95225L46.111 8.48025C45.714 8.00525 45.167 7.76825 44.468 7.76825C43.836 7.76825 43.29 7.99025 42.829 8.43425C42.368 8.87825 42.1381 9.45525 42.1381 10.1643C42.1381 10.8733 42.368 11.4502 42.829 11.8942C43.29 12.3382 43.836 12.5602 44.468 12.5602C45.138 12.5602 45.6971 12.3372 46.1441 11.8902C46.4341 11.5992 46.602 11.1942 46.647 10.6752H44.468V9.95425H47.375C47.405 10.1113 47.418 10.2623 47.418 10.4073Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.90131H49.2961V9.80331H51.7601V10.5243H49.2961V12.4263H52.0281V13.1643H48.5251V7.16431H52.0281V7.90131Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.1643H54.508V7.90131H52.832V7.16431H56.955V7.90131H55.279V13.1643Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.1643V7.16431H60.709V13.1643H59.938Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.1643H63.3572V7.90131H61.6812V7.16431H65.8042V7.90131H64.1281V13.1643Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.3893C73.0189 12.9953 72.2859 13.2983 71.4089 13.2983C70.5319 13.2983 69.7989 12.9953 69.2099 12.3893C68.6199 11.7833 68.3259 11.0413 68.3259 10.1643C68.3259 9.2873 68.6199 8.5453 69.2099 7.9393C69.7989 7.3333 70.5319 7.0293 71.4089 7.0293C72.2809 7.0293 73.0129 7.3343 73.6049 7.9433C74.1969 8.5523 74.4929 9.2923 74.4929 10.1643C74.4929 11.0413 74.1979 11.7833 73.6089 12.3893ZM69.7789 11.8863C70.2229 12.3363 70.7659 12.5603 71.4089 12.5603C72.0519 12.5603 72.5959 12.3353 73.0389 11.8863C73.4829 11.4363 73.7059 10.8623 73.7059 10.1643C73.7059 9.4663 73.4829 8.8923 73.0389 8.4423C72.5959 7.9923 72.0519 7.7683 71.4089 7.7683C70.7659 7.7683 70.2229 7.9933 69.7789 8.4423C69.3359 8.8923 69.1129 9.4663 69.1129 10.1643C69.1129 10.8623 69.3359 11.4363 69.7789 11.8863Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.1643V7.16431H76.513L79.429 11.8313H79.4619L79.429 10.6753V7.16431H80.1999V13.1643H79.3949L76.344 8.27031H76.3109L76.344 9.42631V13.1643H75.5749Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_271_57317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4359 7.70239C10.1449 8.01039 9.9729 8.4884 9.9729 9.1074V31.2234C9.9729 31.8434 10.1449 32.3204 10.4359 32.6284L10.5099 32.7004L22.8989 20.3114V20.1654V20.0194L10.5099 7.62939L10.4359 7.70239Z",
    fill: "url(#paint0_linear_271_57317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0279 24.4422L22.8989 20.3112V20.1652V20.0192L27.0289 15.8892L27.1219 15.9422L32.0149 18.7222C33.4119 19.5162 33.4119 20.8152 32.0149 21.6102L27.1219 24.3902L27.0279 24.4422Z",
    fill: "url(#paint1_linear_271_57317)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_271_57317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 24.389L22.8978 20.165L10.4358 32.628C10.8958 33.116 11.6568 33.176 12.5138 32.69L27.1218 24.389Z",
    fill: "url(#paint2_linear_271_57317)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 15.9413L12.5138 7.64125C11.6568 7.15425 10.8958 7.21525 10.4358 7.70325L22.8988 20.1663L27.1218 15.9413Z",
    fill: "url(#paint3_linear_271_57317)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.16406H128V-0.835938H7V1.16406ZM134 7.16406V33.1641H136V7.16406H134ZM128 39.1641H7V41.1641H128V39.1641ZM1 33.1641V7.16406H-1V33.1641H1ZM7 39.1641C3.68629 39.1641 1 36.4778 1 33.1641H-1C-1 37.5823 2.58172 41.1641 7 41.1641V39.1641ZM134 33.1641C134 36.4778 131.314 39.1641 128 39.1641V41.1641C132.418 41.1641 136 37.5823 136 33.1641H134ZM128 1.16406C131.314 1.16406 134 3.85035 134 7.16406H136C136 2.74578 132.418 -0.835938 128 -0.835938V1.16406ZM7 -0.835938C2.58172 -0.835938 -1 2.74579 -1 7.16406H1C1 3.85035 3.68629 1.16406 7 1.16406V-0.835938Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_271_57317",
    x: 9.9729,
    y: 7.30518,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_57317"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_57317",
    result: "effect2_innerShadow_271_57317"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_271_57317",
    x: 10.4358,
    y: 20.165,
    width: 16.686,
    height: 12.8608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_57317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_271_57317",
    x1: 21.8007,
    y1: 8.87339,
    x2: 5.0187,
    y2: 25.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_271_57317",
    x1: 33.8334,
    y1: 20.1652,
    x2: 9.63753,
    y2: 20.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_271_57317",
    x1: 24.8279,
    y1: 22.4589,
    x2: 2.06939,
    y2: 45.2174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_271_57317",
    x1: 7.29719,
    y1: 0.341052,
    x2: 17.4595,
    y2: 10.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStore);
export default __webpack_public_path__ + "static/media/googleStore.146f0dc3dc11026ea77f0e3ce4ecf6b7.svg";
export { ForwardRef as ReactComponent };